module.exports = __webpack_public_path__ + "media/new_msg.899b1c6d.mp3";